export default import.meta.ROLLDOWN_FILE_URL_uALT36OwjCYh1xG0CuwxPQ